import type { ButtonProps } from "@chakra-ui/react"
import { Button } from "@chakra-ui/react"

import { useIdentity } from "identity/provider"
import type { Chain } from "web3/hooks/useMultichainAccount"

function ConnectAccountButton({
  onOpen,
  shouldPromptAuthenticationAfterWalletConnection = false,
  redirectTo,
  walletType,
  ...buttonProps
}: {
  onOpen?: () => void
  redirectTo?: string
  shouldPromptAuthenticationAfterWalletConnection?: boolean
  walletType?: Chain
} & ButtonProps) {
  const { isAuthenticated, isWalletConnected, authenticate, connectWallet } =
    useIdentity()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()

    onOpen?.()

    if (!isWalletConnected) {
      connectWallet({
        shouldPromptAuthenticationAfterWalletConnection,
        walletType,
      })
    } else {
      authenticate({ redirectTo })
    }
  }

  return (
    <Button
      key="siwe"
      _focusVisible={{
        boxShadow: "none",
        borderColor: "gray.400",
        outline: "3px solid hsla(216, 12%, 84%, 1)",
        outlineOffset: "2px",
      }}
      data-qa="connect-wallet-button"
      fontWeight="bold"
      isDisabled={isAuthenticated}
      variant="primary"
      onClick={handleClick}
      {...buttonProps}
    >
      {isWalletConnected ? "Sign in" : "Connect wallet"}
    </Button>
  )
}

export default ConnectAccountButton
